import React from 'react';

export const MAIN_CONTENT_ID = 'main-content';

export const SkipToMainContent = () => (
  <a className="skip-link" href={`#${MAIN_CONTENT_ID}`}>
    Skip to main content
  </a>
);
